import { render } from "./CreateServiceType.vue?vue&type=template&id=465ebae8"
import script from "./CreateServiceType.vue?vue&type=script&lang=js"
export * from "./CreateServiceType.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__